/* Mavaro — carrousels et bouton retour en haut */
(function () {
  'use strict';

  if (!customElements.get('mavt-slider')) {
    class MavtSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.nav = this.querySelector('[data-slider-nav]');
        if (!this.track || !this.nav) return;
        this.prev = this.nav.querySelector('[data-slider-prev]');
        this.next = this.nav.querySelector('[data-slider-next]');
        this.prev.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.mq = window.matchMedia('(min-width: 750px)');
        this.mq.addEventListener('change', () => this.update());
        window.addEventListener('resize', () => this.update(), { passive: true });
        this.update();
      }
      active() {
        return this.mq.matches ? this.dataset.sliderDesktop === 'true' : this.dataset.sliderMobile === 'true';
      }
      step() {
        const item = this.track.children[0];
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      move(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
      update() {
        const on = this.active() && this.track.scrollWidth > this.track.clientWidth + 2;
        this.nav.hidden = !on;
        if (!on) return;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
    }
    customElements.define('mavt-slider', MavtSlider);
  }

  function initScrollTop() {
    const btn = document.querySelector('[data-mavt-scroll-top]');
    if (!btn) return;
    const after = parseInt(btn.dataset.after || '400', 10);
    const onScroll = () => btn.classList.toggle('is-visible', window.scrollY > after);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
  if (document.readyState !== 'loading') initScrollTop();
  else document.addEventListener('DOMContentLoaded', initScrollTop);
})();
